import axios from 'axios';
import prepareRequestOptions from '../utils/admin-apis.util';

export const createNewChannel = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/channel/create',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const viewChannelById = async (id, isDownload = false) => {
  const options = prepareRequestOptions(
    `/admin/channel/${id}/view${isDownload ? '?download=true' : ''}`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const updateChannelById = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/channel/${id}/update`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const deleteChanelById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/channel/${id}/delete`,
    'DELETE',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getSearchListChannels = async (params = null) => {
  const options = prepareRequestOptions(
    `/admin/channels/search-list?adminUserId=${params.adminUserId}&adminUserRole=${params.adminUserRole}`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const updateConfigById = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/channels/${id}/config`,
    'POST',
    payload,
    true,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const updateDefaultConfigById = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/channels/${id}/default-config`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const updateChannelCategoriesSequence = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/sequence/categories-channel/update',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};
